import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Compass, ArrowRight, Cpu, Briefcase, Scale, HeartPulse, LineChart, PencilRuler,
} from "lucide-react";
import { TRENDING } from "../data/courses";

const icons = { Cpu, Briefcase, Scale, HeartPulse, LineChart, PencilRuler };

export default function CourseFinderCTA() {
  const navigate = useNavigate();
  return (
    <section id="course-finder" className="relative py-16 md:py-24 bg-white overflow-hidden">
      <div className="max-w-[1240px] mx-auto px-5">
        <div className="rounded-3xl bg-[#16244F] relative overflow-hidden p-8 md:p-12">
          <div className="absolute -top-20 -right-16 w-80 h-80 rounded-full bg-[#2b8cf0]/20 blur-3xl" />
          <div className="absolute -bottom-20 -left-16 w-80 h-80 rounded-full bg-[#F58220]/15 blur-3xl" />

          <div className="relative grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-10 items-center">
            <div className="text-white">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 text-[#F9B57C] text-xs font-semibold font-head">
                <Compass size={14} /> COURSE FINDER
              </span>
              <h2 className="font-head text-3xl md:text-4xl font-bold mt-4 leading-snug">
                Find your best-fit course abroad in <span className="text-[#F9B57C]">60 seconds</span>
              </h2>
              <p className="text-white/75 mt-4 max-w-lg">
                Tell us your field, level, destination and budget. Get instantly matched to programs
                with a personalised Fit Score, fees, rankings and scholarship insights.
              </p>
              <div className="flex flex-wrap gap-5 mt-6">
                <div><div className="font-head text-2xl font-extrabold text-[#F9B57C]">850+</div><div className="text-xs text-white/60">universities</div></div>
                <div><div className="font-head text-2xl font-extrabold text-[#F9B57C]">20+</div><div className="text-xs text-white/60">countries</div></div>
                <div><div className="font-head text-2xl font-extrabold text-[#F9B57C]">1 Lakh+</div><div className="text-xs text-white/60">programs</div></div>
              </div>
              <button
                onClick={() => navigate("/course-finder")}
                className="group mt-7 inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#e0730f] text-white font-head font-semibold px-6 py-3.5 rounded-lg transition-colors"
              >
                Start Course Finder <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {TRENDING.map((t) => {
                const Icon = icons[t.icon];
                return (
                  <button
                    key={t.label}
                    onClick={() => navigate("/course-finder")}
                    className="text-left rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-4 transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-lg bg-[#2b8cf0]/20 text-[#7cc0ff] flex items-center justify-center mb-3 group-hover:bg-[#F58220] group-hover:text-white transition-colors">
                      <Icon size={20} />
                    </div>
                    <div className="font-head font-semibold text-white text-sm">{t.label}</div>
                    <div className="text-[11px] text-white/55 mt-1 leading-tight">{t.tags}</div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
